import moment from "moment";
import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/react-hooks";
import Loading from "../../../common/Loading";
import Error from "../../../common/Error";
import {
  GET_USER_ACTIVE_ADDRESS_CHANGE_REQUEST,
  RESOLVE_ADDRESS_CHANGE_REQUEST,
} from "./AddressChangeRequestGqlStatements";

const stringifyAddress = (addressObj) => {
  if (!addressObj || !Object.keys(addressObj).length) {
    return "";
  }
  const {
    normalized_street,
    normalized_city,
    normalized_subdivision,
    normalized_postal_code,
  } = addressObj;
  return `${normalized_street}, ${normalized_city}, ${normalized_subdivision} ${normalized_postal_code}`;
};

const AddressChangeRequest = ({ user }) => {
  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
  } = useQuery(GET_USER_ACTIVE_ADDRESS_CHANGE_REQUEST, {
    variables: {
      userEmail: user.email,
    },
  });
  const [
    resolveAddressChangeRequest,
    {
      loading: resolveRequestLoading,
      error: resolveRequestError,
    },
  ] = useMutation(RESOLVE_ADDRESS_CHANGE_REQUEST, {
    refetchQueries: [
      {
        query: GET_USER_ACTIVE_ADDRESS_CHANGE_REQUEST,
        variables: {
          userEmail: user.email,
        },
      },
    ],
  });
  const [errorMessage, setErrorMessage] = useState(resolveRequestError || "");

  if (queryLoading) {
    return <Loading />;
  }
  if (queryError) {
    console.log("Error querying data with Apollo:", queryError);
    return <Error />;
  }

  const {
    active,
    currentAddress,
    changeToAddress,
    createdAt,
    eventId,
    method,
    redflags,
    updatedAt,
  } = queryData?.getUserActiveAddressChangeRequest || {};

  if (!active) {
    return (
      <div className="mb-5">
        User has no active address change request
      </div>
    );
  }

  return (
    <div className="my-5">
      <div className="mb-5">
        User has an active address change request
      </div>
      <table className={`tomo-table w-auto border ${active ? "border-green-300" : ""}`}>
        <tbody>
          <tr>
            <td>Address Requested:</td>
            <td>{stringifyAddress(changeToAddress)}</td>
          </tr>
          <tr>
            <td>Current Address:</td>
            <td>{stringifyAddress(currentAddress)}</td>
          </tr>
          <tr>
            <td>Request Created:</td>
            <td>{moment(createdAt, "x").format("YYYY-MM-DD LT")}</td>
          </tr>
          <tr>
            <td>Request Updated:</td>
            <td>{moment(updatedAt, "x").format("YYYY-MM-DD LT")}</td>
          </tr>
          <tr>
            <td>Method:</td>
            <td>{method}</td>
          </tr>
          <tr>
            <td>Red flags:</td>
            <td>{redflags}</td>
          </tr>
        </tbody>
      </table>
      <button
        type="button"
        onClick={() => {
          // eslint-disable-next-line no-alert
          const confirmed = window.confirm("Are you sure you want to approve this request?");
          if (confirmed) {
            resolveAddressChangeRequest({
              variables: {
                eventId,
                action: "approve",
              },
            }).then((res) => {
              const { status, message } = res?.data?.resolveAddressChangeRequest || {};
              if (status !== "SUCCESS"){
                setErrorMessage(message);
              }
            });
          }
        }}
        className={`${
          resolveRequestLoading ? "text-gray-primary" : "text-green-primary"
        } p-2`}
        disabled={resolveRequestLoading}
      >
        Approve Request
      </button>
      {errorMessage && (<div className="mb-5 text-red-600 p-2">{errorMessage}</div>)}
    </div>
  );
};

export default AddressChangeRequest;